import { render, staticRenderFns } from "./camera.vue?vue&type=template&id=c2a763e8&scoped=true&"
import script from "./camera.vue?vue&type=script&lang=js&"
export * from "./camera.vue?vue&type=script&lang=js&"
import style1 from "./camera.vue?vue&type=style&index=1&id=c2a763e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a763e8",
  null
  
)

export default component.exports